import { memo } from "react";
import SubscriptionSummaryItem from "./SubscriptionSummaryItem";

interface Subscription {
  id: string;
  name: string;
  price: string;
  plan: string;
  platforms: string[];
  included: string[];
}

interface ClientSummaryProps {
  first_name: string;
  last_name: string;
  username: string;
  userEmail: string;
  password: string;
  subscriptions: Subscription[];
  totalPrice: number;
  expandedIds: Set<string>;
  onToggleExpanded: (id: string) => void;
  isEdit: boolean;
}

function ClientSummary({
  first_name,
  last_name,
  username,
  userEmail,
  password,
  subscriptions,
  totalPrice,
  expandedIds,
  onToggleExpanded,
  isEdit,
}: ClientSummaryProps) {
  console.log(isEdit);
  return (
    <div className="w-full max-w-[300px] space-y-3 text-sm leading-6 font-bold -tracking-wide">
      <h1 className="text-primary">Summary</h1>
      <div className="flex flex-row gap-1">
        <h1>Name:</h1>
        <p className="text-black-300 font-medium">
          {first_name} {last_name || "—"}
        </p>
      </div>
      <div className="flex flex-row gap-1">
        <h1>Username:</h1>
        <p className="text-black-300 font-medium">{username || "—"}</p>
      </div>
      <div className="flex flex-row gap-1">
        <h1>Email:</h1>
        <p className="text-black-300 font-medium break-all">
          {userEmail || "—"}
        </p>
      </div>
      {!isEdit && (
        <div className="flex flex-row gap-1">
          <h1>Temporary Password</h1>
          <p className="text-black-300 font-medium break-all">
            {password || "—"}
          </p>
        </div>
      )}
      <h1 className="text-primary">Subscription/s:</h1>
      <div className="">
        {subscriptions.length === 0 ? (
          <p className="text-black-300 text-xs font-medium italic">
            No subscriptions selected
          </p>
        ) : (
          subscriptions.map((subscription) => (
            <SubscriptionSummaryItem
              key={subscription.id}
              id={subscription.id}
              name={subscription.name}
              price={subscription.price}
              plan={subscription.plan}
              platforms={subscription.platforms}
              isExpanded={expandedIds.has(subscription.id)}
              onToggle={() => onToggleExpanded(subscription.id)}
            />
          ))
        )}
      </div>
      <div className="border-b border-white"></div>
      <div className="flex w-full flex-row justify-between gap-1">
        <h1>Total:</h1>
        <p className="font-medium text-white">
          {subscriptions.length > 0
            ? `$${totalPrice.toLocaleString()}/mo`
            : "$0/mo"}
        </p>
      </div>
    </div>
  );
}

export default memo(ClientSummary);
